import Vue from 'vue';
import apiClient from '@/apiClient';

const state = {
  materials: [],
  materialTypes: [],
  materialSubtypes: [],
  materialGroups: [],
  units: []
};

const getters = {
  getMaterialsByPartId: state => partId =>
    state.materials.filter(
      material => material.partsId === parseInt(partId, 10)
    )
};

const actions = {
  getMaterialTypes: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/materials/types`)
        .then(resp => {
          resp.data.materialTypes.map(materialType => {
            materialType.collapsed = false;
          });
          commit('materialTypes', resp.data.materialTypes);
          commit('materialSubtypes', resp.data.materialSubtypes);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  getMaterialGroups: ({ commit }, firmId) =>
    new Promise((resolve, reject) => {
      apiClient
        .get(`/firms/${firmId}/materials/groups`)
        .then(resp => {
          resp.data.materialGroups.map(materialGroup => {
            materialGroup.collapsed = true;
          });

          resp.data.materialGroups.forEach(group => {
            group.material_types.map(type => {
              type.collapsed = true;
            });
          });

          commit('materialGroups', resp.data.materialGroups);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  getUnits: ({ commit }) =>
    new Promise((resolve, reject) => {
      apiClient
        .get('constructors/units')
        .then(resp => {
          commit('units', resp.data.units);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  deleteMaterial: ({ dispatch }, { firmId, constructorId, materialId }) =>
    new Promise((resolve, reject) => {
      apiClient
        .delete(`/constructors/materials/${materialId}`)
        .then(resp => {
          dispatch('getMaterials', { firmId, constructorId });
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateMaterial: ({ dispatch }, { firmId, constructorId, materialId, data }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/constructors/materials/${materialId}`, data)
        .then(resp => {
          dispatch('getMaterials', { firmId, constructorId, materialId });
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateMaterialTypeName: ({ dispatch }, { firmId, typeId, title }) =>
    new Promise((resolve, reject) => {
      apiClient
        .patch(`/firms/${firmId}/materials/types/${typeId}`, { title })
        .then(resp => {
          dispatch('getMaterialTypes', firmId);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateMaterialSubtypeName: ({ dispatch }, { firmId, subtypeId, data }) =>
    new Promise((resolve, reject) => {
      apiClient
        .patch(`/firms/${firmId}/materials/types/subtypes/${subtypeId}`, data)
        .then(resp => {
          dispatch('getMaterialTypes', firmId);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateMaterialTypeMarkup: ({ dispatch }, { firmId, data }) =>
    new Promise((resolve, reject) => {
      apiClient
        .put(`/firms/${firmId}/markups`, data)
        .then(resp => {
          dispatch('getMaterialTypes', firmId);
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    }),

  updateMaterialTypePriceBatch: ({ dispatch }, { firmId, data }) =>
    new Promise((resolve, reject) => {
      apiClient
        .patch(`/firms/${firmId}/materials`, data)
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          reject(err);
        });
    })
};

const mutations = {
  materials: (state, materials) => {
    Vue.set(state, 'materials', materials);
  },
  materialGroups: (state, materialGroups) => {
    Vue.set(state, 'materialGroups', materialGroups);
  },
  units: (state, units) => {
    Vue.set(state, 'units', units);
  },
  materialTypes: (state, materialTypes) => {
    Vue.set(state, 'materialTypes', materialTypes);
  },
  materialSubtypes: (state, materialSubtypes) => {
    Vue.set(state, 'materialSubtypes', materialSubtypes);
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};
